module.exports = __webpack_public_path__ + "assets/img/deckmaster-XL-orange-lose.fe8c023c.png";